import { GoogleAuthProvider, signInWithPopup, signOut, type User } from "firebase/auth";
import { FiLogIn, FiLogOut } from "react-icons/fi";
import { auth } from "../services/firebaseClients";
import { friendlyFirebaseError } from "../utils";

interface AuthButtonProps {
  user: User | null;
  onError: (message: string) => void;
}

export function AuthButton({ user, onError }: AuthButtonProps) {
  const handleSignIn = async () => {
    try {
      await signInWithPopup(auth, new GoogleAuthProvider());
    } catch (error) {
      onError(friendlyFirebaseError(error));
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      onError(friendlyFirebaseError(error));
    }
  };

  return user ? (
    <button className="clip-auth-button" type="button" onClick={handleSignOut} title={user.email ?? undefined}>
      <FiLogOut aria-hidden="true" /> Sign out
    </button>
  ) : (
    <button className="clip-auth-button primary" type="button" onClick={handleSignIn}>
      <FiLogIn aria-hidden="true" /> Sign in to upload
    </button>
  );
}
